import * as Utils from './utils/index';

export function getDefaultAppConfig() {
  return {
    skipForm: false,
    comments: true,
    qna: true,
    userCount: true,
    screenshot: true,
    liveBadge: true,
  };
}

export function getAppConfig(clientConfig = {}) {
  const config = {
    ...getDefaultAppConfig(),
    ...clientConfig,
    jwtData: clientConfig.jwt ? Utils.parseJwt(clientConfig.jwt) : {},
  };
  return config;
}

export function validateClientConfig(config) {
  const contEl = document.getElementById(config.contEl);
  if (!contEl) {
    return [false, 'Invalid container element passed'];
  }
  if (config.castMode) {
    return [true];
  }
  if (!config.eventId) {
    return [false, 'Invalid event id passed'];
  }
  if (!config.public) {
    if (!config.jwt) {
      return [false, 'JWT not passed'];
    } else {
      const jwtData = Utils.parseJwt(config.jwt);
      if (!jwtData) {
        return [false, 'Invalid JWT passed'];
      }
      if (!jwtData.eventID) {
        return [false, 'Invalid JWT passed'];
      }
    }
  }
  return [true];
}
